// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-d8985956]{flex-direction:column;background-color:#fff;border-radius:3px;margin-top:20px}.footer[data-v-d8985956],.top[data-v-d8985956]{display:flex;align-items:center;justify-content:space-between}.top[data-v-d8985956]{flex-direction:row;width:100%;padding:10px 20px}.btn+.btn[data-v-d8985956]{margin-left:20px}.buttons[data-v-d8985956]{display:flex}.status .--bold[data-v-d8985956]{font-weight:600}", ""]);
// Exports
module.exports = exports;
